import React, { createContext, useState } from 'react';

interface StansalonePathExplorerContextType {
    detailesPanelOpened: boolean;
    selectedHeader: string;
    selectedType: string;
    barChartData: any[];
    setDetailesPanelOpened: (opened: boolean) => void;
    setSelectedHeader: (headerId: string) => void;
    setSelectedType: (type: string) => void;
    setBarChartData: (data: any[]) => void;
}

const StandalonePathExplorerContext = createContext<StansalonePathExplorerContextType | undefined>(undefined);

export const StandalonePathExplorerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [detailesPanelOpened, setDetailesPanelOpened] = useState<boolean>(false)
    const [selectedHeader, setSelectedHeader] = useState<string>(null)
    const [selectedType, setSelectedType] = useState<string>(null)
    const [barChartData, setBarChartData] = useState(null)

    return (
        <StandalonePathExplorerContext.Provider value={{ detailesPanelOpened, selectedHeader, selectedType, barChartData, setDetailesPanelOpened, setSelectedHeader, setSelectedType, setBarChartData }}>
            {children}
        </StandalonePathExplorerContext.Provider>
    );
}

export default StandalonePathExplorerContext;
